export default __webpack_public_path__ + "static/media/searching-octopus.e1a345a3.png";